import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as blueprintReducer from "containers/Blueprint/reducer";
import * as setupReducer from "containers/Setup/reducer";
import { getStep, updateStep } from "containers/CreateWizard/reducer";

import ContinuousImpact from "components/CreateWizard/Costs/ContinuousImpact";

class ContinuousImpactContainer extends React.PureComponent {
  render() {
    const { step, index, isShow } = this.props;

    return <ContinuousImpact {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateStep: (step) => dispatch(updateStep(step)),
  updateConversionGain: (conversionGain) => dispatch(setupReducer.updateConversionGain(ownProps.id, conversionGain)),
  updateConversionCost: (conversionCost) => dispatch(setupReducer.updateConversionCost(ownProps.id, conversionCost)),
  updateConversionMissed: (conversionMissed) =>
    dispatch(setupReducer.updateConversionMissed(ownProps.id, conversionMissed)),
  updateConversionSaved: (conversionSaved) =>
    dispatch(setupReducer.updateConversionSaved(ownProps.id, conversionSaved)),

  updateCustomValue: (id, value) =>
    dispatch(setupReducer.updateCustomValue(ownProps.id, ownProps.blueprintId, id, value)),

  updateOverestimateLabel: (overestimateLabel) =>
    dispatch(setupReducer.updateOverestimateLabel(ownProps.id, overestimateLabel)),
  updateUnderestimateLabel: (underestimateLabel) =>
    dispatch(setupReducer.updateUnderestimateLabel(ownProps.id, underestimateLabel)),

  updateIsAdvanced: (isAdvanced) => dispatch(blueprintReducer.updateIsAdvanced(ownProps.blueprintId, isAdvanced)),
  updateCustomField: (customField) => dispatch(blueprintReducer.updateCustomField(ownProps.blueprintId, customField)),
  updateCustomFieldById: (id, customField) =>
    dispatch(blueprintReducer.updateCustomFieldById(ownProps.blueprintId, id, customField)),
  updateAdvancedInput: (id, evaluator) =>
    dispatch(blueprintReducer.updateAdvancedInput(ownProps.blueprintId, id, evaluator)),

  updateIsSimpleCosts: (isSimpleCosts) => dispatch(setupReducer.updateIsSimpleCosts(ownProps.id, isSimpleCosts))
});

const mapStateToProps = (state, ownProps) => {
  const setupBlueprintId = setupReducer.getBlueprintId(state, ownProps.id);

  return {
    conversionGain: setupReducer.getConversionGain(state, ownProps.id),
    conversionCost: setupReducer.getConversionCost(state, ownProps.id),

    isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",

    outcome: setupReducer.getOutcomeFromDataset(state, ownProps.id),
    success: setupReducer.getSuccessValue(state, ownProps.id),

    timePeriod: setupReducer.getTimePeriod(state, ownProps.id),

    customValues: setupReducer.getCustomValues(state, ownProps.id),
    isSimpleCosts: setupReducer.getIsSimpleCosts(state, ownProps.id),

    overestimateLabel: setupReducer.getOverestimateLabel(state, ownProps.id),
    underestimateLabel: setupReducer.getUnderestimateLabel(state, ownProps.id),

    isAdvanced: blueprintReducer.getIsAdvanced(state, setupBlueprintId ? setupBlueprintId : ownProps.blueprintId),
    customFields:
      ownProps.id === "new"
        ? blueprintReducer.getCustomFields(state, ownProps.blueprintId)
        : blueprintReducer.getCustomFields(state, setupBlueprintId),
    advancedInputs: blueprintReducer.getAdvancedInputs(state, ownProps.blueprintId),

    isEditing: blueprintReducer.getIsEditing(state, ownProps.blueprintId),

    step: getStep(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ContinuousImpactContainer);
